export default {
    setReservedAccounts: function (state, payload) {
        if (payload && payload.loading) {
            state.reservedAccount = { loading: true };
        }
        else if (payload) {
            state.reservedAccount = payload.error ? payload : {
                pageInfo: payload.page_info,
                reserved: payload["Merchant_Accounts"]
            };
        }
        else {
            state.reservedAccount = payload;
        }
    },
    setCreateReserve: function (state, payload) {
        state.createReserve = payload;
    },
    setReservedAccountsDetails: function (state, payload) {
        state.reservedAccountsDetails = payload;
    },
    setDashboardBankAccounts: function (state, value) {
        state.dashboardBankAccounts = value;
    },
    setReservedPayouts: function (state, value) {
        state.ReservedAccountPayouts = value;
    },
};
